import { render, staticRenderFns } from "./CanvasToolbarTop.vue?vue&type=template&id=b34f9074&scoped=true"
import script from "./CanvasToolbarTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./CanvasToolbarTop.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CanvasToolbarTop.vue?vue&type=style&index=0&id=b34f9074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34f9074",
  null
  
)

export default component.exports